import gsap from "gsap";
import "./util/common";
import Scrollmove from "./util/scrollmove";
import Headerfix from "./util/headerfix";
import Wheeldata from "./util/wheeldata";

if(!promokitStore.isBnsInGame) {
    let $element = $(`[data-fix="contents"]`);
    let isAnimation = false;
    let scrollCheck = true;

    $element.on("end", ()=>{
        if(!isAnimation) return;
        isAnimation = false;
    });

    $("#container").on("mousewheel DOMMouseScroll", (e)=>{
        if(isAnimation) {e.preventDefault(); return;}
        if(Wheeldata(e)>0 && scrollCheck){
            e.preventDefault();
            isAnimation = true;
            Scrollmove.move(`[data-fix="contents"]`);
        }
    });

    $(window).on("scroll", (e)=>{
        let scTop = $(e.currentTarget).scrollTop();
        scrollCheck = scTop<$element.offset().top ? true : false ;
    });

    $(window).on("resize", (e)=>{
        Headerfix(window.innerHeight);
    }).resize();

    $(".p-header__btn").on("click", (e)=>{
        isAnimation = true;
        Scrollmove.move(`[data-fix="contents"]`);
    });

    const headerAni = gsap.timeline({paused: true})
        .from('.p-header__cht1', 0.94, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.3')
        .from('.p-header__cht2', 0.94, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '-=0.67')
        // .from('.p-header__stit', 0.76, {y:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.46')
        .from('.p-header__tit', 0.76, {y:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.46')
        .from('.p-header__update', 0.76, {y:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.46')
        .from('.p-header__btn-video', 0.76, {y:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.46')
        .add(() => { $(".p-header__scroll").addClass("p-header__scroll--animation")}, '-=0.96')
        .from('.other', 0.76, {x:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.16');
    // .from('.p-header__btn', 0.76, {y:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.46')
    // .from('.other', 0.76, {x:100, alpha:0, ease: 'Power1.easeOut'}, '-=0.46');

    promokit.preload({
        complete: function() {
            headerAni.play();
        }
    });
}else{
    $(".p-header").css({display:"none"});
}


// WEBPACK FOOTER //
// ./src/js/index.js